import { render } from "./form.vue?vue&type=template&id=15859f60&ts=true"
import script from "./form.vue?vue&type=script&lang=ts"
export * from "./form.vue?vue&type=script&lang=ts"

import "./form.vue?vue&type=style&index=0&id=15859f60&lang=less"

import exportComponent from "D:\\test\\newDemo\\alp-ui\\vue-component\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__